import { useEffect, useRef } from 'react'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { cn } from '../../lib/cn'

/**
 * Free OpenStreetMap map (raster tiles via Leaflet) — no API key, no Google,
 * no WebGL requirement, so it renders in any Capacitor webview. The marker is a
 * branded circle to avoid Leaflet's default icon-asset bundling issue.
 */
export function MapView({ lat, lon, zoom = 16, className }: { lat: number; lon: number; zoom?: number; className?: string }) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const map = L.map(el, { scrollWheelZoom: false, zoomControl: true, attributionControl: true }).setView([lat, lon], zoom)
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '© OpenStreetMap',
    }).addTo(map)
    L.circleMarker([lat, lon], { radius: 9, color: '#ffffff', weight: 3, fillColor: '#b31917', fillOpacity: 1 }).addTo(map)
    // settle layout (the container may mount at 0 height inside cards)
    setTimeout(() => map.invalidateSize(), 0)
    return () => {
      map.remove()
    }
  }, [lat, lon, zoom])

  return <div ref={ref} className={cn('z-0', className)} aria-label="map" />
}
